export const getStrapiGraphqlPageQuery = (
  slug: string,
  locale: string
) => `query($status: PublicationStatus) { 
pages: pages(locale: "${locale}", status: $status, filters: {slug: {eq: "${slug}"}}) {
          contents {
            __typename
            ... on ComponentSharedBanner {
              mainMediaBlock {
                title
                subtitle
                media {
                      url
                }
                mediaMobile {
                      url
                }
              }
                callToAction {
                  label
                  url
                  color
                }
            }
            ... on ComponentSharedCarousel {
              title
              items (pagination: { limit: 100 }) {
                title
                description
                link
                linkText
                image {
                      url
                }
              }
              CTA {
                label
                url
                color
              }
            }
            ... on ComponentSharedGrid {
              title
              subtitle
              background
              items {
                caption
                title
                content
                image {
                      url
                }
                imagePosition
                CTA {
                  label
                  url
                  color
                }
                rows
                columns
                background
                alignment
              }
            }
            ... on ComponentSharedFaqSection {
              title
              subtitle
              questions {
                question
                answer
              }
            }
            ... on ComponentSharedEventsList {
              title
              listType
              isDurationVisible
            }
            ... on ComponentSharedReviews {
              title
              subtitle
              items {
                rating
                content
                author
                date
                CTA {
                  label
                  url
                }
              }
            }
            ... on ComponentSharedText {
              title
              text
              image {
                    url
              }
              imagePosition
              cta {
                label
                url
              }
            }
            ... on ComponentSharedPricing {
              title
              subtitle
              pricingPlan {
                title
                subtitle
                highlight
                pricingFeature {
                  featureDescription
                  enabled
                }
                pricingPlanKey
                CTA {
                  label
                  url
                  color
                }
              }
            }
            ... on ComponentFooterFooterBlock {
              title
              items (pagination: { limit: 100 }) {
                label
                link
              }
            }
            ... on ComponentSharedSeo {
              metaTitle
              metaDescription
              metaImage {
                    url
              }
              keywords
            }
          }
    }
  }
  `
